import React, { memo } from 'react';
import { useTimerStatus } from './hooks';
import Trigger from './Trigger';
import Counter from './Counter';

function Timer() {
  const status = useTimerStatus();

  if (status === 'OVERLAY') {
    return <Trigger />;
  } else if (status === 'COUNTDOWN') {
    return <Counter />;
  }

  return null;
}

export default memo(Timer);
